import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { fuseAnimations } from '@fuse/animations';
import { SubjectUrl } from 'app/shared/models/subject-url';
import { Url } from 'app/shared/models/url';
import { SubjectUrlService } from 'app/shared/services/subject-url.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'url-dialog',
  templateUrl: './url-dialog.component.html',
  styleUrls: ['./url-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class UrlDialogComponent implements OnInit {

  title: string;
  subjectUrl: SubjectUrl;
  form: UntypedFormGroup;

  constructor(
    private subjectUrlService: SubjectUrlService,
    public dialogRef: MatDialogRef<UrlDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.subjectUrl = this.data.subjectUrl || new SubjectUrl({url: new Url()});
    this.title = (this.subjectUrl && this.subjectUrl.id) ? 'Edit URL' : 'Add URL';
    this.form = this.formBuilder.group({
      link: [this.subjectUrl.url.link, Validators.required],
      summary: [this.subjectUrl.url.summary],
    });
  }

  save(){
    const val = this.form.getRawValue();
    this.subjectUrl.url.summary = val.summary;
    this.subjectUrl.url.link = val.link;
    // check if link has a http/https/or other prefix.  If it does not, add http://
    if (!this.subjectUrl.url.link.includes('://')){
      this.subjectUrl.url.link = 'http://' + this.subjectUrl.url.link;
    }
    this.subjectUrlService.onAfterSave.pipe(take(1)).subscribe((_) => {
      this.dialogRef.close();
    })
    this.subjectUrlService.save(this.subjectUrl);
  }
}
